import { render, staticRenderFns } from "./Counselor.vue?vue&type=template&id=d5431648&scoped=true&"
import script from "./Counselor.vue?vue&type=script&lang=js&"
export * from "./Counselor.vue?vue&type=script&lang=js&"
import style0 from "./Counselor.vue?vue&type=style&index=0&id=d5431648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5431648",
  null
  
)

export default component.exports